<template>
    <div class="main-bd mg20">
    <slot name="table_head"></slot>
    <el-table :data="data" @row-click="showDetail" :row-style="{cursor:'pointer'}">
        <el-table-column prop="customer_name" label="线索名称"></el-table-column>
        <el-table-column prop="contact_name" label="申请人"></el-table-column>
        <el-table-column prop="position" label="所在地区"></el-table-column>
        <el-table-column prop="source_name" label="线索来源"></el-table-column>
        <el-table-column prop="apply_time" label="申请时间"></el-table-column>
    </el-table>
    </div>
</template>
<script>
    export default {
        name: "Clue",
        props: {
            data: {
                required: false
            },
        },
        methods:{
            showDetail:function (data) {
                let path = "/sales-leads/view?id=" + data.id;
                let go_to = {
                    path: path,
                    query: {
                        referer: this.$route.path
                    }
                }
                this.$router.push(go_to);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/home/tab/Clue.vue